// for the hover for the menu items
var windowWidth = window.innerWidth;
if (windowWidth > 989) {
	var listMenuDetails = document.querySelectorAll(".list-menu details");

	// Spielkonsolen-Untermenue (2026-09-08): oeffnet/schliesst per Klick statt Hover.
	// Bleibt offen, bis erneut auf den Menuepunkt, ausserhalb des Menues oder auf eine
	// Unterkollektion geklickt wird. Alle anderen Menuepunkte behalten das Hover-Verhalten.
	var clickMenuDetails = document.querySelectorAll(".list-menu details.js-click-submenu");

	function closeClickSubmenus(except) {
		clickMenuDetails.forEach(function(c) {
			if (!c.hasAttribute("open")) return;
			if (except && (c.contains(except) || except.contains(c))) return;
			c.removeAttribute("open");
			c.querySelector(".header__menu-item").classList.remove("active");
			c.querySelector("summary").setAttribute("aria-expanded", "false");
		});
	}

	listMenuDetails.forEach(function(item) {
		if (item.classList.contains("js-click-submenu")) return;

		item.addEventListener("mouseenter", function() {
			this.setAttribute("open", "");
			this.querySelector(".header__menu-item").classList.add("active");
			closeClickSubmenus(this);
		});

		item.addEventListener("mouseleave", function() {
			this.removeAttribute("open");
			this.querySelector(".header__menu-item").classList.remove("active");
		});
	});

	clickMenuDetails.forEach(function(item) {
		item.addEventListener("toggle", function() {
			this.querySelector(".header__menu-item").classList.toggle("active", this.hasAttribute("open"));
		});
		item.querySelectorAll("a").forEach(function(link) {
			link.addEventListener("click", function() {
				item.removeAttribute("open");
			});
		});
	});

	if (clickMenuDetails.length) {
		document.addEventListener("click", function(event) {
			clickMenuDetails.forEach(function(item) {
				if (item.hasAttribute("open") && !item.contains(event.target)) {
					item.removeAttribute("open");
					item.querySelector(".header__menu-item").classList.remove("active");
					item.querySelector("summary").setAttribute("aria-expanded", "false");
				}
			});
		});
	}
}
